
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  ILeanTestComponentProps,
  ILeanTestComponentMapperProps,
  ILeanTestComponentControllerProps,
  ILeanTestComponentStateValues,
} from '../../../components/LeanTestComponent/LeanTestComponent.props';

export default withCompController<
  ILeanTestComponentMapperProps,
  ILeanTestComponentControllerProps,
  ILeanTestComponentProps,
  ILeanTestComponentStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
